export default __webpack_public_path__ + "static/media/ET.6832bdac.svg";